export default __webpack_public_path__ + "static/media/07.47df360f.jpg";